module.exports = __webpack_public_path__ + "img/td.e135f422.svg";